import { DeleteOutlined, PlusCircleOutlined } from '@ant-design/icons';
import { useQuery } from '@apollo/client/react';
import { css } from '@emotion/css';
import { Button, Flex, Form, Input, Select, Space, Typography, theme } from 'antd';
import { AIS_LINK_VENDORS_QUERY } from './DoctorAisLinks.gql';

export const DoctorAisLinksField = () => {
  const { token } = theme.useToken();
  const { data } = useQuery(AIS_LINK_VENDORS_QUERY);
  const linkVendors = data?.aisLinkVendors ?? [];
  const aisLinks: { vendor?: string }[] | undefined = Form.useWatch('aisLinks');
  const usedVendors = aisLinks?.map(link => link?.vendor) ?? [];
  const unusedVendor = linkVendors.find(v => !usedVendors.includes(v.key));
  const codeFont = css`
    font-family: ${token.fontFamilyCode};
  `;
  const helpText = css`
    margin: 0 0 ${token.margin}px;
    color: ${token.colorTextSecondary};
    font-size: ${token.fontSizeSM}px;
  `;
  const section = css`
    margin-bottom: ${token.marginLG}px;
  `;
  const deleteButton = css`
    margin-top: ${token.lineHeight * token.fontSize + token.paddingXS}px;
  `;

  return (
    <div className={section}>
      <Typography.Title level={5}>AIS-Verknüpfungen</Typography.Title>
      <Typography.Paragraph className={helpText}>
        Die Kennung, unter der das AIS diesen Zuweiser führt. AIS-Benutzer, denen das AIS diese Kennung zuordnet, arbeiten in labcomplete®
        für diesen Zuweiser. Pro Zuweiser ist je Hersteller eine Kennung möglich.
      </Typography.Paragraph>
      <Form.List name="aisLinks">
        {(fields, { add, remove }) => (
          <Space size="middle" orientation="vertical" style={{ width: '100%' }}>
            <Button
              icon={<PlusCircleOutlined />}
              disabled={!unusedVendor}
              onClick={() => add({ vendor: unusedVendor?.key, externalId: '' })}
            >
              Verknüpfung hinzufügen
            </Button>
            <div>
              {fields.map(({ key, name, ...restField }) => (
                <Flex key={key} gap="middle" align="flex-start">
                  <Form.Item
                    {...restField}
                    name={[name, 'vendor']}
                    label="Hersteller"
                    rules={[{ required: true, message: 'Bitte Hersteller wählen' }]}
                  >
                    <Select
                      style={{ width: 200 }}
                      placeholder="Hersteller wählen"
                      options={linkVendors.map(v => ({
                        value: v.key,
                        label: v.displayName,
                        disabled: aisLinks?.some((link, index) => index !== name && link?.vendor === v.key),
                      }))}
                    />
                  </Form.Item>
                  <Form.Item
                    style={{ flexGrow: 1 }}
                    {...restField}
                    name={[name, 'externalId']}
                    label="Kennung beim Hersteller"
                    rules={[{ required: true, whitespace: true, message: 'Bitte Kennung angeben' }]}
                  >
                    <Input className={codeFont} />
                  </Form.Item>
                  <Button
                    className={deleteButton}
                    icon={<DeleteOutlined />}
                    type="text"
                    danger
                    aria-label="Verknüpfung löschen"
                    onClick={() => remove(name)}
                  />
                </Flex>
              ))}
            </div>
          </Space>
        )}
      </Form.List>
    </div>
  );
};
